import { useSectionEventOnViewportEntrance } from '@/hooks/useSectionEventOnViewportEntrance';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { type Coverage, type CoverageSectionVariant, CoverageSection } from './Coverage';
import { CarPageContext } from './CarPageContext';

export interface BasicCoveragesProps {
  title: string;
  subtitle: string;
  coverages: Coverage[];
  darkBackground: boolean;
  variant?: CoverageSectionVariant;
}

const StyledCoverageSection = styled(CoverageSection)`
  z-index: 1;
`;

const BasicCoverages: React.FC<BasicCoveragesProps> = ({ variant = 'default', ...props }) => {
  const { analytics } = useContext(CarPageContext);
  const intersectionRef = useSectionEventOnViewportEntrance({
    sectionName: 'basicCoverages',
    page: analytics?.page,
    position: 4,
  });

  return (
    <StyledCoverageSection
      ref={intersectionRef}
      {...props}
      variant={variant}
      itemWidth={[220, 248, 220]}
      itemMargin={[20, 50]}
    />
  );
};

export default React.memo(BasicCoverages);
